function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../ThemeProvider/useBuildStyleWithTheme";
import { useMemo } from "react";
var OVERALL_WIDTH = 40;
var HANDLE_OFFSET_START_POS = 12;
var HANDLE_OFFSET_END_POS = 28;
var HANDLE_WIDTH = 20;
var buildStyle = function(theme, param) {
    var readingDirection = param.readingDirection, start = param.start;
    var animation = theme.animation, backgroundColor = theme.backgroundColor, borderColor = theme.borderColor, size = theme.size;
    var animationTimingFunc = "".concat(animation.productive.easeIn.duration.fast, " ").concat(animation.productive.easeIn.easing);
    var _obj;
    return {
        'switch-track': {
            base: {
                position: 'relative',
                appearance: 'none',
                boxSizing: 'border-box',
                outline: 'none',
                border: 'none',
                display: 'block',
                backgroundColor: backgroundColor.fillNeutral.base,
                borderRadius: size.border.radius.round,
                width: OVERALL_WIDTH,
                height: 24,
                transition: "background-color ".concat(animation.duration[300], ", box-shadow ").concat(animation.productive.easeInOut.easing, " ").concat(animation.duration[100]),
                cursor: 'pointer',
                '&:focus': {
                    boxShadow: "0 0 0 2px ".concat(borderColor.interactive.focus)
                }
            },
            on: {
                backgroundColor: backgroundColor.interactive.fill.base
            },
            disabled: {
                backgroundColor: backgroundColor.brand.disabled,
                cursor: 'not-allowed'
            }
        },
        'switch-thumb': {
            base: (_obj = {
                position: 'absolute',
                transform: 'translate(-50%, -50%)',
                top: '50%'
            }, _defineProperty(_obj, start.direction, HANDLE_OFFSET_START_POS), _defineProperty(_obj, "height", 20), _defineProperty(_obj, "width", 20), _defineProperty(_obj, "borderRadius", size.border.radius.fiveX), _defineProperty(_obj, "backgroundColor", backgroundColor.base), _defineProperty(_obj, "transition", "transform ".concat(animationTimingFunc)), _obj),
            'base-rtl': _defineProperty({}, start.direction, HANDLE_OFFSET_START_POS - HANDLE_WIDTH),
            on: {
                base: {
                    transform: 'translate(30%, -50%)'
                },
                rtl: {
                    transform: 'translate(-130%, -50%)'
                }
            }
        },
        container: _objectSpread({}, readingDirection, {
            display: 'inline-block'
        }),
        buttonContainer: {
            width: '100%'
        }
    };
};
var useStyle = function(param) {
    var on = param.on, disabled = param.disabled, isRtl = param.isRtl;
    var style = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    return useMemo(function() {
        var ref, ref1, ref2;
        return {
            trackStyles: _objectSpread({}, style === null || style === void 0 ? void 0 : style['switch-track'].base, on && (style === null || style === void 0 ? void 0 : style['switch-track'].on), disabled && (style === null || style === void 0 ? void 0 : style['switch-track'].disabled)),
            thumbStyles: _objectSpread({}, style === null || style === void 0 ? void 0 : style['switch-thumb'].base, isRtl && (style === null || style === void 0 ? void 0 : (ref = style['switch-thumb']) === null || ref === void 0 ? void 0 : ref['base-rtl']), on && (style === null || style === void 0 ? void 0 : (ref1 = style['switch-thumb']) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.on) === null || ref2 === void 0 ? void 0 : ref2[isRtl ? 'rtl' : 'base'])),
            container: _objectSpread({}, style === null || style === void 0 ? void 0 : style.container),
            buttonContainer: _objectSpread({}, style === null || style === void 0 ? void 0 : style.buttonContainer)
        };
    }, [
        disabled,
        isRtl,
        on,
        style
    ]);
};
export default useStyle;
